import { render, staticRenderFns } from "./ListDatasourceAccessRequested.vue?vue&type=template&id=336b8ce7&lang=pug"
import script from "./ListDatasourceAccessRequested.vue?vue&type=script&lang=js"
export * from "./ListDatasourceAccessRequested.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('336b8ce7')) {
      api.createRecord('336b8ce7', component.options)
    } else {
      api.reload('336b8ce7', component.options)
    }
    module.hot.accept("./ListDatasourceAccessRequested.vue?vue&type=template&id=336b8ce7&lang=pug", function () {
      api.rerender('336b8ce7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ListDatasourceAccessRequested.vue"
export default component.exports